// Telemetry. Rap - stands for Recent Attachment Pill

// data point triggered when initializing the pills
export const DP_RECENT_ATTACHMENT_PILLS_INITIALIZE = 'Rap_Initialize';

// data point triggered when user click 'x' to close the pills
export const DP_RECENT_ATTACHMENT_PILLS_FORCE_CLOSE = 'Rap_ForceClose';

// data point triggered when user click 'x' to close the pills
export const DP_RECENT_ATTACHMENT_PILLS_EXPAND = 'Rap_ClickExpand';

// data point triggered when user click 'Add all' button
export const DP_RECENT_ATTACHMENT_PILLS_ADD_ALL = 'Rap_AddAll';

// data point triggered when user click on individual pill attachment
export const DP_RECENT_ATTACHMENT_PILLS_CLICK_PILL = 'Rap_ClickPill';

// data point triggered when expand button display
export const DP_SHOW_EXPAND_BUTTON = 'Rap_ShowExpandButton';

// data point to indicate general interaction - will trigger only once when user click on either: individual pill, 'add all' button or expand button
export const DP_RECENT_ATTACHMENT_PILLS_GENERAL_INTERACTION = 'Rap_GeneralInteraction';

// source of general Interaction
export const ON_EXPAND = 'onExpand';
export const ON_ADD_ALL = 'onAddAll';
export const ON_PILL_CLICK = 'OnPillClick';
